import { Form, Button } from 'react-bootstrap';
import styles from '../pa_checklist_followup.module.scss'
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import SelectInput from '../../../Misc/SelectInput/SelectInput';
import MultiCheckboxSelect from './tinyComps/filtro_custom_produtos';

const listaLocalizacao = [
  { value: 420, label: 'LOCALIZADO NA REVISÃO' },
  { value: 440, label: 'LOCALIZADO NO CHECKLIST' }
];

const FiltroChecklistFup = () => {
  const { filterForm, setFilterForm, listaStatusCadeia, listaCanal, listaOrigem, listaColecao, listaMarca, listaTipoProduto, getFilteredGrid, limparFiltros, listaStatusFinal } = usePAChecklistFollowUp();

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '164px',
      padding: '0',
      borderColor: state.isFocused ? '#2684FF' : '#ddd',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
      '&:hover': {
        borderColor: '#2684FF',
        cursor: 'pointer',
      },
      textAlign: 'left',
      cursor: 'pointer'
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  }

  const customFilter = (option, searchText) => {
    if (!searchText) return true;
    return option.label.toLowerCase().includes(searchText.toLowerCase());
  }

  return (
    <Form className={styles.filter_wrapper}>
      <MultiCheckboxSelect
        value={filterForm.colecao}
        onChange={e => setFilterForm({ ...filterForm, colecao: e })}
        options={listaColecao}
        placeholder={'Coleção'}
        width={'164px'}
      />

      <MultiCheckboxSelect
        value={filterForm.marca}
        onChange={e => setFilterForm({ ...filterForm, marca: e })}
        options={listaMarca}
        placeholder={'Marca'}
        width={'164px'}
      />

      <MultiCheckboxSelect
        value={filterForm.canal}
        onChange={e => setFilterForm({ ...filterForm, canal: e })}
        options={listaCanal}
        placeholder={'Canal'}
        width={'164px'}
      />

      <MultiCheckboxSelect
        value={filterForm.tipo_produto}
        onChange={e => setFilterForm({ ...filterForm, tipo_produto: e })}
        options={listaTipoProduto}
        placeholder={'Tipo de Produto'}
        width={'164px'}
      />

      <MultiCheckboxSelect
        value={filterForm.origem}
        onChange={e => setFilterForm({ ...filterForm, origem: e })}
        options={listaOrigem}
        placeholder={'Origem'}
        width={'338px'}
      />

      <MultiCheckboxSelect
        value={filterForm.status_cadeia}
        onChange={e => setFilterForm({ ...filterForm, status_cadeia: e })}
        options={listaStatusCadeia}
        placeholder={'Status de Cadeia'}
        width={'338px'}
      />

      <MultiCheckboxSelect
        value={filterForm.status_final}
        onChange={e => setFilterForm({ ...filterForm, status_final: e })}
        options={listaStatusFinal}
        placeholder={'Resultado'}
        width={'164px'}
      />

      <SelectInput
        label={'Localização'}
        style={{ width: '164px', alignSelf: 'end' }}
        value={filterForm.localizacao || null}
        onChange={e => setFilterForm({ ...filterForm, localizacao: e })}
        options={listaLocalizacao}
        customSelectStyles={customSelectStyles}
        isClearable={true}
        filterOption={customFilter}
      />

      <SelectInput
        label={'Priorizado?'}
        style={{ width: '164px', alignSelf: 'end' }}
        value={filterForm.priorizado || null}
        onChange={e => setFilterForm({ ...filterForm, priorizado: e })}
        options={[{ label: 'NÃO', value: 0 }, { label: 'SIM', value: 1 }]}
        customSelectStyles={customSelectStyles}
        isClearable={true}
        filterOption={customFilter}
      />

      <SelectInput
        label={'Finalizado?'}
        style={{ width: '164px', alignSelf: 'end' }}
        value={filterForm.finalizado || null}
        onChange={e => setFilterForm({ ...filterForm, finalizado: e })}
        options={[{ label: 'NÃO', value: 0 }, { label: 'SIM', value: 1 }]}
        customSelectStyles={customSelectStyles}
        isClearable={true}
        filterOption={customFilter}
      />

      <Form.Group className={styles.filter_group} style={{ minWidth: '338px' }}>
        <Form.Label className={styles.filter_label}>OP, OS, NF, Produto ou Desc. Produto</Form.Label>
        <Form.Control
          className={styles.filter_control}
          type={'text'}
          placeholder={'OP, OS, NF, Produto ou Desc. Produto'}
          value={filterForm.multi || ''}
          onChange={e => setFilterForm({ ...filterForm, multi: e.target.value })}
        />
      </Form.Group>

      <Form.Group className={styles.filter_group} style={{ width: '164px' }}>
        <Form.Label className={styles.filter_label}>Data Recebimento Início</Form.Label>
        <Form.Control
          className={styles.filter_control}
          type="date"
          value={filterForm.data_recebimento_inicio || ''}
          onChange={e => setFilterForm({ ...filterForm, data_recebimento_inicio: e.target.value })}
        />
      </Form.Group>

      <Form.Group className={styles.filter_group} style={{ width: '164px' }}>
        <Form.Label className={styles.filter_label}>Data Recebimento Fim</Form.Label>
        <Form.Control
          className={styles.filter_control}
          type="date"
          value={filterForm.data_recebimento_fim || ''}
          onChange={e => setFilterForm({ ...filterForm, data_recebimento_fim: e.target.value })}
        />
      </Form.Group>

      <Button
        className={styles.filter_btn}
        variant={'secondary'}
        style={{ fontWeight: '500' }}
        onClick={getFilteredGrid}
      >
        Filtrar
      </Button>

      <Button
        className={styles.filter_btn}
        variant={'warning'}
        style={{ fontWeight: '500' }}
        onClick={limparFiltros}
      >
        Limpar Filtros
      </Button>
    </Form>
  );
}

export default FiltroChecklistFup;
